import type { FaireProductEntity } from "../../entity_types/product";

export const caden_lane_4: FaireProductEntity = {
  token: "caden-lane-4",
  type: "product",
  name: "Sweet Like Candy Convertible Zip Romper | Pink",
  brandName: "Caden Lane",
  imageUrl:
    "https://cdn.faire.com/fastly/776029370d7fa17b7b87c878c03f4364e1416a82257ea78ad8d2a2e9675d0b61.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&precrop=1798,1798,x0,y0,safe&width=720",
  priceDollars: 20,
  msrpDollars: 40,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_apparel-baby"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
